import type { IOnlineStudyPlannerSectionBlockViewModel } from '../../ViewModel/StudyPlanner/IOnlineStudyPlannerSectionBlockViewModel.csharp';
import type { LegacyOnlineStudyPlannerSectionBlockViewModel } from '../../ViewModel/StudyPlanner/Legacy/LegacyOnlineStudyPlannerSectionBlockViewModel.csharp';
import type { OnlineStudyPlannerSectionBlockViewModel } from '../../ViewModel/StudyPlanner/OnlineStudyPlannerSectionBlockViewModel.csharp';
import { OnlineStudyPlannerSectionBlockViewModelType } from '../../ViewModel/StudyPlanner/OnlineStudyPlannerSectionBlockViewModelType.csharp';

export const isLegacyView = (
    viewModel: IOnlineStudyPlannerSectionBlockViewModel
): viewModel is LegacyOnlineStudyPlannerSectionBlockViewModel =>
    viewModel.type === OnlineStudyPlannerSectionBlockViewModelType.LegacyView;

export const isNewView = (
    viewModel: IOnlineStudyPlannerSectionBlockViewModel
): viewModel is OnlineStudyPlannerSectionBlockViewModel =>
    viewModel.type === OnlineStudyPlannerSectionBlockViewModelType.View;
